<template>
    <span class="input-group-text input-group-help" key="help">
        ?
        <div class="css-help">
                    {{selectedProp.help}}
        </div>
    </span>
</template>
<script>
export default {
    name: 'CssHelpTooltip',
    props: {
        selectedProp: {}
    }
};

</script>
<style lang="scss" scoped>
    .input-group-help {
        position: relative;
        .css-help {
            position: absolute;
            bottom: 100%;
            right: -100%;
            background-color: #00b2fa;
            color: #fff;
            font-size: 1.2em;
            white-space: initial;
            width: 800%;
            visibility: hidden;
            padding: 10px;
        }
        &:hover {
            .css-help {
                visibility: visible;
            }
        }
    }

</style>
